import $ from 'jquery'
import { nestableEffectId } from '../config/data'
import { EditorSelection } from '../types/editor'
/**
* 删除空特效
* @param startNode 
* @param endNode 
*/
export const removeEmptyEffect = (startNode: Node, endNode: Node) => {
  const range = new Range()
  range.setStartBefore(startNode)
  range.setEndAfter(endNode)
  if (range.toString().trim() === '') {
    $(startNode).remove()
    $(endNode).remove()
  }
}
/**
* 点击移除按钮 删除特效 的逻辑
* @param effectType 特效類型
* @param idName id名称比如speedhover
* @param date id值（因为通常是日期）
* @param nodeRange range
* @param isType 0,1,2;0指内部嵌套自己，需要删除内部特效，1，外部嵌套自己，range传起始到特效开始，
* 只需要把特效前后移动，2、判断是否包含不成对某个特效，
*/
export const updateEffctRange = (effectType: string, idName: any, date: number, nodeRange: DocumentFragment, isType: number) => {
  let localSpeedStartList = $(nodeRange).find(`.${effectType}Start`)
  let localSpeedEndList = $(nodeRange).find(`.${effectType}End`)
  if (localSpeedStartList.length > 0 || localSpeedEndList.length > 0) {
    let startEffectNodeMap = {},
      endEffEctNodeMap = {}
    for (let i = 0; i < localSpeedStartList.length; i++) {
      let node = localSpeedStartList[i]
      let id = node.getAttribute(`data-${idName}`)
      startEffectNodeMap[id] = $(`#${effectType}Start_${id}`)
    }
    for (let i = 0; i < localSpeedEndList.length; i++) {
      let node = localSpeedEndList[i]
      let id = node.getAttribute(`data-${idName}`)
      if (startEffectNodeMap[id]) {
        if (isType == 0) {
          $(`#${effectType}Start_${id}`).remove()
          $(`#${effectType}End_${id}`).remove()
        }
        delete startEffectNodeMap[id]
      } else {
        endEffEctNodeMap[id] = $(`#${effectType}End_${id}`)
      }
    }
    let startEffectNodeKey = Object.keys(startEffectNodeMap)
    let endEffEctNodeKey = Object.keys(endEffEctNodeMap)
    if (startEffectNodeKey.length > 0) {
      if (isType == 2) {
        return [startEffectNodeMap, endEffEctNodeMap]
      }
      startEffectNodeKey.forEach(key => {
        if (isType == 1) {
          let $startNode = startEffectNodeMap[key]
          let $startNode2 = $startNode.clone(true);
          $startNode2.insertAfter(`#${effectType}End_${date}`)
          let id = $startNode.attr(`data-${idName}`)
          $startNode.attr(`data-${idName}`, id + '1')
          $startNode.attr(`id`, `${effectType}Start_${id + '1'}`)
          let $endNode2 = $(`#${effectType}End_${id}`)
          $endNode2
            .clone(true)
            .insertBefore(`#${effectType}Start_${date}`)
          let $endnode = $(`#${effectType}End_${id}`)
          $endnode.attr(`data-${idName}`, id + '1')
          $endnode.attr(`id`, `${effectType}End_${id + '1'}`)

          removeEmptyEffect($startNode[0], $endnode[0])
          removeEmptyEffect($startNode2[0], $endNode2[0])
        } else {
          startEffectNodeMap[key].insertAfter(`#${effectType}End_${date}`)
        }
      })
    }
    if (endEffEctNodeKey.length > 0) {
      if (isType == 2) {
        return [startEffectNodeMap, endEffEctNodeMap]
      }
      endEffEctNodeKey.forEach(key => {
        $(endEffEctNodeMap[key]).insertBefore(`#${effectType}Start_${date}`)
      })
    }
  }
}

/**
 * 判断选区是否有指定特效
 * @param currentRange 选区
 * @param effectType 特效类型 
 * @param nestingType 1,2,3 1代表允许内部嵌套，2代表允许外部嵌套，3代表都不允许
 * @returns [boolean]
 * 
 */
export const hasEffectRange = (currentRange: Range, effectType: string | string[], nestingType: number = 3) => {
  if (!currentRange) return false
  if (Array.isArray(effectType)) {
    const effectTypeList = effectType
    for (let effectType of effectTypeList) {
      if (hasEffectRange(currentRange, effectType, nestingType)) return true
    }
    return false
  }
  const contents = currentRange.cloneContents();

  // 单标签嵌套
  const placeholderEffects = {
    'multi-tone': ".effect-multi-tone", // 多音字
    'stress': ".effect-stress", // 重音
    'pause': ".pause-item", //停顿
    'mute': ".effect-mute", // 静音
    // 3: ".effect-multi-tone", // 连读 todo
    // 6: ".effect-multi-tone", // 局部变速 todo
    'globalMute': ".effect-global-mute", //段落静音
    // 7: ".effect-multi-tone", //多发音人 todo
  };
  if (placeholderEffects[effectType]) {
    return !!contents.querySelector(placeholderEffects[effectType])
  }

  // 内部嵌套
  const nestableEffects = {
    'liandu': ".lianduStart", // 连读
    'localSpeed': ".localSpeedStart", // 局部变速
    'multiSpeaker': ".multiSpeakerStart", //多发音人
    'aliasChange': ".aliasChangeStart", //别名
    'phonetics': ".phoneticsStart",
  };

  if (contents.querySelector(nestableEffects[effectType]) && nestingType !== 1) {
    return true
  }
  console.log('nestingType', effectType, nestingType);

  if (nestingType == 2) {//不再檢查外部嵌套

    return false
  }
  // 外部嵌套

  let range = new Range();
  range.setStart($(".editor")[0], 0);
  range.setEnd(currentRange.startContainer, currentRange.startOffset);
  let iswrap = updateEffctRange(
    effectType,
    nestableEffectId[effectType],
    0,
    range.cloneContents(),
    2
  );
  return !!iswrap
}
/**
* 校验连读
*/
const checkLiandu = (range: Range) => {
  if (!range) {
    return '请选中2-10个字以内的文本'
  }

  let $rangeContent = $(range.cloneContents())
  if ($rangeContent.find('div').length > 1) {
    return '请选中一句话内的文字'
  }

  const textLength = $rangeContent.text().replace(/\s/g, '').length
  if (textLength <= 1 || textLength > 10) {
    return '请选中2-10个字以内的文本'
  }

  if (hasEffectRange(range, ['phonetics', 'aliasChange', 'liandu'])) {
    return "连读暂不支持与当前功能组合使用"
  }

  if (hasEffectRange(range, 'phonetics', 1)) {
    return "连读暂不支持与当前功能组合使用"
  }

  return ''
}
/**
* 校验局部变速
*/
const checkLocalSpeed = (range: Range) => {
  if (!range) {
    return '请选中多个汉字'
  }

  let $rangeContent = $(range.cloneContents())
  if ($rangeContent.text().replace(/\s/g, '').length <= 1) {
    return '请选中多个汉字'
  }

  if (hasEffectRange(range, ['aliasChange', 'phonetics', 'liandu'], 1)) {
    return "局部变速暂不支持与当前功能组合使用"
  }

  return ''
}
/**
* 校验多发音人
*/
const checkMultiSpeaker = (range: Range) => {
  if (!range) {
    return "请选中多个汉字"
  }

  let $rangeContent = $(range.cloneContents())
  if ($rangeContent.text().replace(/\s/g, "").length <= 0) {
    return "请选中多个汉字"
  }


  if (hasEffectRange(range, ['phonetics', 'aliasChange', 'liandu'], 1)) {
    return "多发音人暂不支持与当前功能组合使用"
  }

  return ''
}
/**
* 校验音标
*/
const checkPhonetics = (range: Range) => {
  if (!range) {
    return "请选择英文单词"
  }

  let $rangeContent = $(range.cloneContents())
  if ($rangeContent.text().replace(/\s/g, "").length <= 0) {
    return "请选择英文单词"
  }

  if (hasEffectRange(range, ['aliasChange', 'phonetics'])) {
    return "音标暂不支持与当前功能组合使用"
  }

  if (hasEffectRange(range, ['localSpeed', 'multiSpeaker', 'liandu'], 2)) {
    return "音标暂不支持与当前功能组合使用"
  }

  return ''
}
//判断是否包含空白字符和标点符号
function containsWhitespaceAndPunctuation(text: string) {
  let regex = /[\n`~!@#$%^&*()+=<>?:"{}|,./;'[\]！￥……（）——【】‘；：”“。，、？]/;
  return regex.test(text);
}
/**
* 校验别名
*/
const checkAliasChange = (selection: { range: any }) => {
  let range = selection.range
  if (!range) {
    return "请选择需要设置别名的文字"
  }
  let $rangeContent = $(range.cloneContents())
  let text = $rangeContent.text()
  let textLength = text.replace(/\s/g, "").length
  if (textLength <= 0 || textLength > 10) {
    return "请选中十个字以内的文本"
  }
  // 判断是否有标点符号或者空白字符
  if (containsWhitespaceAndPunctuation(text)) {
    return "请选中一句话以内的文本"
  }

  if (hasEffectRange(range, ['aliasChange', 'phonetics', 'liandu', 'multi-tone'])) {
    return "别名暂不支持与当前功能组合使用"
  }
  if (hasEffectRange(range, 'aliasChange')) {
    return "此文本已设置别名"
  }

  if (hasEffectRange(range, ['localSpeed', 'multiSpeaker'], 2)) {
    return "别名暂不支持与当前功能组合使用"
  }

  return ''
}
/**
* 校验停顿调节
*/
const checkPauseMute = (range: Range) => {
  if (hasEffectRange(range, ['phonetics', 'aliasChange', 'liandu'])) {
    return "停顿调节暂不支持与当前功能组合使用"
  }
  return ''
}
/**
* 校验多音字
*/
const checkMultiTone = (range: Range) => {
  let $rangeContent = $(range.cloneContents())
  if ($rangeContent.text().replace(/\s/g, '').length >= 2) {
    return '请选择单个汉字'
  }

  if (hasEffectRange(range, ['aliasChange', 'phonetics'], 1)) {
    return "多音字暂不支持与当前功能组合使用"
  }

  return ''
}
/**
* 校验选区是否有效
* @param type 特效类型
* @param selection 选区
* @returns [string]
* 
*/
export const checkRangeValid = (type: any, selection: EditorSelection) => {
  let range = selection.range || selection.caret
  let errorMessage = ''
  switch (type) {
    case 'showLiandu':
    case 'liandu':
      errorMessage = checkLiandu(range)
      break
    case 'showLocalSpeed':
    case 'localSpeed':
      errorMessage = checkLocalSpeed(range)
      break
    case 'showMultiSpeaker':
    case 'multiSpeaker':
      errorMessage = checkMultiSpeaker(range)
      break
    case 'phonetics':
      errorMessage = checkPhonetics(range)
      break
    case 'aliasChange':
      errorMessage = checkAliasChange(selection)
      break
    case 'pause':
    case 'mute':
      errorMessage = checkPauseMute(range)
      break
    case 'multi-tone':
      errorMessage = checkMultiTone(range)
      break
    default:
      break
  }
  // this.selectedEffectValue = value
  return errorMessage
}
//前端页面的音量0-100 转成算法需要的0.01-1.40
export const getArithmeticVolume = (currentVolume: number) => {
  let volume: any = currentVolume;
  volume = (1.4 * volume / 100).toFixed(2)
  // 算法支持最小值是0.01
  return volume * 1 < 0.01 ? 0.01 : volume
}


export class rangeChangeHandler {
  dom: any
  range: Range
  ischangeType: number
  momentumTimeout: any

  constructor(dom: any) {
    this.dom = dom;
    this.ischangeType = 0;
    this.momentumTimeout = null;

    this.handleTouchStart = this.handleTouchStart.bind(this);
    this.handleTouchMove = this.handleTouchMove.bind(this);
    this.handleTouchEnd = this.handleTouchEnd.bind(this);

    this.dom.addEventListener("touchstart", this.handleTouchStart);
    this.dom.addEventListener("touchmove", this.handleTouchMove);
    this.dom.addEventListener("touchend", this.handleTouchEnd);
  }

  /**
   * Handles the touch start event.
   *
   * @param {Event} event - The touch start event object.
   */
  handleTouchStart(Event: any) {
    // debugger
    let selection = window.getSelection();

    if (selection.type !== 'Range') {
      return
    }
    this.range = selection.getRangeAt(0);
    this.ischangeType = confirmRangeChange(Event, this.range);


    // 获取光标的所在位置
    // const pointRange = document.caretRangeFromPoint(clientX, clientY);

  }

  /**
   * Handles the touch move event.
   *
   * @param {TouchEvent} event - The touch event object.
   */
  handleTouchMove(event: any) {
    let x = event.changedTouches[0].clientX || event.clientX;
    let y = event.changedTouches[0].clientY || event.clientY;
    if (this.ischangeType == 1) {
      let range2 = document.createRange();
      let sel = window.getSelection();
      let caretRange = document.caretRangeFromPoint(x, y+10);
      range2.setStart(caretRange.startContainer, caretRange.startOffset);
      range2.setEnd(this.range.endContainer, this.range.endOffset);
      sel.removeAllRanges();
      sel.addRange(range2);
    } else if (this.ischangeType == 2) {
      let range2 = document.createRange();
      let sel = window.getSelection();
      let caretRange = document.caretRangeFromPoint(x, y-10);
      // console.log('caretRange', caretRange);
      range2.setStart(this.range.startContainer, this.range.startOffset);
      range2.setEnd(caretRange.startContainer, caretRange.startOffset);
      sel.removeAllRanges();
      sel.addRange(range2);
    } else {
      if (this.momentumTimeout) {
        clearTimeout(this.momentumTimeout);
        this.momentumTimeout = null
      }
    }
  }

  /**
   * Handles the touch end event.
   *
   * @param {Event} event - The touch end event.
   */
  handleTouchEnd(event: any) {
    this.ischangeType = 0
    if(this.momentumTimeout){
      clearTimeout(this.momentumTimeout);
      this.momentumTimeout = null;
    }
  
  }
}
function confirmRangeChange(Event: any, range: Range) {
  let range2 = document.createRange();
  range2.setStart(range.startContainer, range.startOffset);
  range2.setEnd(range.startContainer, range.startOffset);

  let clientX = Event.clientX || Event.touches[0].clientX;
  let clientY = Event.clientY || Event.touches[0].clientY;
  let rect = range2.getBoundingClientRect();
  let startDistance = Math.sqrt(
    (rect.left - clientX) ** 2 + (rect.top - clientY) ** 2
  );
  range2.setStart(range.endContainer, range.endOffset);
  range2.setEnd(range.endContainer, range.endOffset);
  rect = range2.getBoundingClientRect();
  let endDistance = Math.sqrt(
    (rect.left - clientX) ** 2 + (rect.top - clientY) ** 2
  );
  range2.detach();
   if (endDistance < 40&&startDistance < 40) {
    return startDistance < endDistance ? 1 : 2;
  }else if (startDistance < 40) {
    return 1
  } else if (endDistance < 40) {
    return 2
  } else {
    return 0
  }

}